import Modal from "@/components/modal";

export type PartnerData = {
  partner: boolean;
  partnerLink: string;
  partnerCode: string;
  heading: string;
  text: string;
  price: string;
};

export default function PartnerModal({
  data,
  onClose,
}: {
  data: PartnerData;
  onClose: () => void;
}) {
  return (
    <Modal open={!!data} close={() => onClose()} title="Buy & Train" large>
      <div className="mt-2">
        <p className="block font-medium text-sm text-gray-500 pb-2">
          {data?.heading}
        </p>
        <p className="block medium text-gray-700">{data.text}</p>
        <div className="flex justify-end mt-4">
          <div className="w-44">
            <a
              href={data.partnerLink}
              target="_blank"
              rel="noreferrer"
              className="w-full flex items-center justify-center px-5 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-900"
            >
              Buy Now
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
}
